import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function QRPHDoorStickerDetails({ navigation }) {
  const [details, setDetails] = useState({
    not_visible_p1_door_sticker_description: "",
    p1_door_sticker_not_visible_reason: "",
    qrph_door_sticker_location: "",
    other_reason_p1_door_sticker_not_visible: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    newErrors.qrph_door_sticker_location = !details.qrph_door_sticker_location;
    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validate()) {
      try {
        localStorage.setItem('install-sqr-origin', 'qrph-sticker-details');
      } catch (e) { /* ignore */ }
      if (navigation && navigation.go) navigation.go('install-sqr-merch');
    }
  };

  const handleBack = () => {
     navigation.previous();
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">QRPH DOOR STICKER DETAILS</h4>
              <p className="form-desc">Please fill in the details for the QRPH door sticker</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                

                  {/* QRPH door sticker location */}
                  <Form.Group className={`mb-4 ${errors.qrph_door_sticker_location ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      QRPH door sticker location
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        "glass door - eye level",
                        "glass door- not eye level",
                        "counter",
                        "glass window",
                        "others",
                      ].map((reason) => (
                        <div key={reason} className={`form-radio-item${details.qrph_door_sticker_location === reason ? " selected" : ""}`}>
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_door_sticker_location"
                              value={reason}
                              label={reason}
                              checked={details.qrph_door_sticker_location === reason}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.qrph_door_sticker_location && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                   Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default QRPHDoorStickerDetails;
